import { DELIVERY_AGENCY_REPORT_IN_PROGRESS_STATUS_CODES } from '~/constants';

import type { DeliveryResultReportShippingLabelStatusCount } from '~/types/delivery-agency.types';

/**
 * [배송 결과 리포트] 서머리 '진행 중' 합산 카운트
 *
 * @remarks
 * BE는 상태별 카운트만 내려주므로, 출고 대기/진행중 + 배송 중을 프론트에서 합산해 '진행 중'으로 표기한다.
 */
export const getReportInProgressCount = (
  shippingLabelStatusCounts: DeliveryResultReportShippingLabelStatusCount[] | undefined
): number =>
  (shippingLabelStatusCounts ?? [])
    .filter((item) => DELIVERY_AGENCY_REPORT_IN_PROGRESS_STATUS_CODES.some((code) => code === item.code))
    .reduce((total, item) => total + item.count, 0);
